import React, {Component} from 'react';
import { connect } from 'react-redux';

var $ = require('jquery');
$.ui = require('jquery-ui');
//$.ui.position = require('../node_modules/jquery-ui/ui/position.js');

import Keyboard from 'react-screen-keyboard';
import {doAjax} from '../helpers.js';

const KeyboardLayout = {
  symbolsKeyValue: 'Abc',
  layout: [['@','q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'], ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'], ['z', 'x', 'c', 'v', 'b', 'n', 'm', '.']]
};

class LoginP extends Component {
  state = {
    register: false,
    input: null
    }
  title() {
    return this.state.forgot ? "Recover password" : this.state.register ? "Register" : "Login";
    }
  render() {
    console.log("LOGIN Render", this.state);

    var register = this.state.register;
    var forgot = this.state.forgot;
    var login = !register && !forgot;
    var title = this.title();
    var self = this;
    return(
      <div>
      <div className="row">
        <div className="col-md-4 offset-4 dialog login" ref="dialog" style={{marginLeft: "33.333333%", background: "#fff", border: "1px solid #000", borderRadius: 6, padding: 15, textAlign: "center"}}>
          <h4 style={{color: "#333"}} >{title}</h4>
          {this.state.error ? <div className="alert-danger">{this.state.error}</div> : null }
          {login && this.props.external_login ? 
            <div>
            <div className="social">
              <a id="google_login" className="btn btn-google" href="/auth/google_oauth2">
                <i className="fa fa-google-plus fa-fw"/> Login con Google
              </a>
              <a id="facebook_login" className="btn btn-facebook" href="/auth/facebook">
                <i className="fa fa-facebook fa-fw"></i> Login con Facebook
              </a>
              <a id="windows_login" className="btn btn-windows" href="/auth/windowslive">
                <i className="fa fa-windows fa-fw"></i> Login con Hotmail/Microsoft
              </a>
              <a id="password_login" className="btn btn-password" onClick={function() {self.state.ask_password = true;self.setState(self.state);}}>
                Login con email
              </a>
            </div>
            <div className="division" />
            </div>
          : null }
          { (!this.props.external_login || this.state.ask_password) ? 
          <div>
          {register ? <input className="form-control" placeholder="Name" ref="name" required="true" onFocus={() => this.setState({input: "name"})}/> : null }
          <input className="form-control" placeholder="Email" ref="email" onFocus={() => this.setState({input: "email"})} />
          {this.props.require_password && !forgot ?
            <input className="form-control" type="password" placeholder="Password" ref="password"/> : null }
          {this.props.require_password && register ?
            <input className="form-control" type="password" placeholder="Password Confirmation" ref="password2"/> : null }
          <button className="btn btn-default btn-login" onClick={() => this.login()}>{title}</button>
          {register || forgot ? null
          : <span className="modal-footer">
              <button className="btn btn-warning btn-login" onClick={() => this.setState({register: true})}>Register</button>
              { this.props.require_password &&
              <span> &nbsp;-&nbsp;
              <a onClick={() => this.setState({forgot: true})}>Don't remember your password?</a></span> }
            </span> }
          </div>
          : null }
        </div>
      </div>
      { !Config.web && this.state.input ?
      <div className="row">
        <Keyboard inputNode={this.refs[this.state.input]} layouts={[KeyboardLayout]}/>
      </div> : null }
      </div>
      );
    }
  componentDidMount() {
    this.forceUpdate(); // para q se active el teclado
    window.addEventListener("resize", this.recalc_pos);
    }
  componentWillUnmount() {
    $(document.body).off('keydown', this.handleKeyDown);
    }
  handleKeyDown(e) {
    if ( e.keyCode == 27 ) {
      this.props.cancel();
      }
    }
  login() {
    var d = {action: this.state.forgot ? "recover" : this.state.register ? "register" : "login",
             name: this.refs.name ? this.refs.name.value : "",
             email: this.refs.email ? this.refs.email.value : "",
             pass: this.refs.password ? this.refs.password.value : "",
             pass2: this.refs.password2 ? this.refs.password2.value : ""};
    this.props.sendLogin((this.props.url || "/login")+"?"+$.param(d));
    }
  }

function after_login(v, dispatch, getState)
{
  dispatch({type: "STATUS_SET", v: v});

  if (getState().after_login && getState().usuario.id) { // logueado!
    let req = getState().after_login;
    dispatch({type: "STATUS_SET", v: {after_login: null}});
    doAjax(...req)(dispatch, getState);
    }
}

export const Login = connect(st => ({external_login: Config.web, require_password: Config.web}),
                             d => ({sendLogin: (url) => d(doAjax(url, "POST", after_login))
                                    }))(LoginP);

export const AdminLogin = connect(st => ({external_login: false, require_password: true, url: "/admin/login"}),
                             d => ({sendLogin: (url) => d(doAjax(url, "POST", after_login))
                                    }))(LoginP);
